export default __webpack_public_path__ + "static/media/suspension.20dfb0ee.png";